import axios from 'axios'
import { ForecastBreakdownResponse, RevenueBreakdownResponse, SubscriptionBreakdownResponse } from '../interfaces/accountsInterfaces'

// baseURL + auth are configured centrally by src/api/authAxios.ts. These calls use
// relative paths that resolve against the global axios baseURL (the API), and the
// bearer is attached by the shared interceptor.

export const getForecastBreakdown = async (month: string): Promise<ForecastBreakdownResponse> => {
  const response = await axios.get(`/accounts/forecast-breakdown/${month}`)
  return response.data
}

export const getRevenueBreakdown = async (month: string): Promise<RevenueBreakdownResponse> => {
  const response = await axios.get(`/accounts/revenue-breakdown/${month}`)
  return response.data
}

export const getSubscriptionBreakdown = async (): Promise<SubscriptionBreakdownResponse> => {
  const response = await axios.get('/accounts/subscription-breakdown')
  return response.data
}

export interface ActivityMatrixResponse {
  signup_buckets: string[]
  activity_buckets: string[]
  matrix: Record<string, Record<string, number>>
}

export const getActivityMatrix = async (membership: string = 'paid'): Promise<ActivityMatrixResponse> => {
  const response = await axios.get(`/accounts/activity-matrix?membership=${membership}`)
  return response.data
}

export interface ActivityMatrixOrg {
  uuid: string
  name: string
  membership: string | null
  tier: string | null
  created_at: string | null
  last_activity: string | null
  total_scans: number
}

export const getActivityMatrixOrgs = async (
  signupBucket: string,
  activityCategory: string,
  membership: string = 'paid',
): Promise<ActivityMatrixOrg[]> => {
  const params = new URLSearchParams({
    signup_bucket: signupBucket,
    activity_category: activityCategory,
    membership,
  })
  const response = await axios.get(`/accounts/activity-matrix/orgs?${params}`)
  return response.data
}
